import { Number, String } from "runtypes";

export const PositiveNumber = Number.withConstraint(n => n >= 0, { name: 'Positive Number' })
export const DateString = String.withConstraint(s => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d{2,3})?$/.test(s) || `Date should be in the format ^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}.\\d{2}$ received ${s}`, { name: 'Date String' })